import React from 'react';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import { action, computed, makeObservable, observable, reaction } from 'mobx';
import { inject, observer } from 'mobx-react';
import '../../../../css/processo.css';
import ReactComponent from '../../../ReactComponent';
import Decisao from './Decisao';
import Ementa from './Ementa';
import { lightBlue } from '@mui/material/colors';
import ComparacaoDecisaoRascunhoCertidao from './ComparacaoDecisaoRascunhoCertidao';
import RascunhoPreSessao from './RascunhoPreSessao';
import CloseIcon from '@mui/icons-material/Close';

class PreSessaoEmentaDecisao extends ReactComponent {
    rascunhoDecisaoContainerRef = React.createRef();

    openDialog = false;
    alturaRascunho = 0;

    constructor(props) {
        super(props);

        makeObservable(this, {
            openDialog: observable,
            alturaRascunho: observable,
            calculaAlturaRascunho: action,
            registro: computed,
            handleOpenDialog: action,
            handleCloseDialog: action
        });
    }

    calculaAlturaRascunho = () => {
        if (this.rascunhoDecisaoContainerRef?.current?.clientHeight < window.innerHeight) {
            this.alturaRascunho = this.rascunhoDecisaoContainerRef?.current?.clientHeight - 185;
        } else {
            this.alturaRascunho = 0;
        }
    };

    componentDidMount() {
        this.salaSessaoStore.carregarEmentaDecisao(this.registro);
        this.calculaAlturaRascunho();
        window.addEventListener('resize', this.calculaAlturaRascunho);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.calculaAlturaRascunho);
    }

    reactionRegistro = reaction(
        () => this.registro,
        () => {
            this.salaSessaoStore.carregarEmentaDecisao(this.registro);
        }
    );

    get registro() {
        return this.observableProps.registro;
    }

    handleOpenDialog = () => {
        this.openDialog = true;
    };

    handleCloseDialog = () => {
        this.openDialog = false;
    };

    render() {
        return (
            <Box
                sx={{
                    display: 'flex',
                    flex: 1,
                    gap: 2,
                    boxSizing: 'border-box',
                    lineHeight: '1.5em',
                    flexDirection: 'row'
                }}
            >
                <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1, pb: 0.5 }}>
                    <Typography sx={{ fontWeight: 'bold', color: lightBlue[900], margin: 1, ml: 0 }}>
                        Ementa:
                    </Typography>
                    <Box
                        sx={{
                            flex: 1,
                            display: 'flex',
                            overflowY: 'auto',
                            flexDirection: 'column',
                            border: '1px solid rgba(0, 0, 0, 0.23)',
                            borderRadius: '4px',
                            padding: '8px'
                        }}
                    >
                        <Ementa
                            registro={this.registro}
                            minHeight={'25vh'}
                            maxHeight={'25vh'}
                        />
                    </Box>
                </Box>
                <Box
                    ref={this.rascunhoDecisaoContainerRef}
                    sx={{ display: 'flex', flexDirection: 'column', flex: 1, pb: 0.5, position: 'relative' }}
                >
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            flex: 1,
                            position: 'absolute',
                            width: '100%',
                            alignItems: 'flex-end',
                            top: '-2px'
                        }}
                    >
                        <ComparacaoDecisaoRascunhoCertidao registro={this.registro} />
                    </Box>
                    <Box sx={{ display: 'flex', flexDirection: 'column', pt: 1 }}>
                        <RascunhoPreSessao
                            registro={this.registro}
                            alturaRascunho={this.alturaRascunho}
                        />
                    </Box>
                </Box>
                <Dialog
                    open={this.openDialog}
                    onClose={this.handleCloseDialog}
                    maxWidth="lg"
                    style={{ minHeight: '400px' }}
                >
                    <DialogTitle>Decisão</DialogTitle>
                    <DialogContent>
                        <Decisao registro={this.registro} />
                    </DialogContent>
                    <DialogActions>
                        <Button
                            onClick={this.handleCloseDialog}
                            color="primary"
                            variant="outlined"
                            endIcon={<CloseIcon />}
                        >
                            Fechar
                        </Button>
                    </DialogActions>
                </Dialog>
            </Box>
        );
    }
}

export default inject('stores')(observer(PreSessaoEmentaDecisao));
